(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text-read-more"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-text-read-more]').forEach(function (block) {
    if (block.dataset.readMoreInit) return;
    block.dataset.readMoreInit = 'true';

    const toggle = block.querySelector('[data-text-read-more-toggle]');
    const moreLabel = block.querySelector('[data-text-read-more-label-more]');
    const lessLabel = block.querySelector('[data-text-read-more-label-less]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      const expanded = block.getAttribute('data-expanded') === 'true';
      block.setAttribute('data-expanded', String(!expanded));
      toggle.setAttribute('aria-expanded', String(!expanded));
      moreLabel.hidden = !expanded ? true : false;
      lessLabel.hidden = !expanded ? false : true;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
